import { apiService } from 'shared/api'

import { LoginUserResponse } from './auth'

const apiUrl =
  process.env.NEXT_PUBLIC_HOME_URL?.includes('lokalnyrolnik.pl') ||
  process.env.NEXT_PUBLIC_HOME_URL?.includes(
    'lokalnyrolnik-frontend-test.vercel.app'
  )
    ? `${process.env.NEXT_PUBLIC_API_URL || ''}`.replace('pl/api', 'pl')
    : `${process.env.NEXT_PUBLIC_API_URL || ''}`.replace('/api', '')

const api = apiService(apiUrl)

export const redirectToGoogleLogin = () => api.get('/login/redirect/google')
export const googleLoginCallback = (
  query: string
): Promise<LoginUserResponse> => api.get(`/login/google/callback${query}`)

export const appleLoginCallback = (query: string): Promise<LoginUserResponse> =>
  api.get(`/login/apple/callback${query}`)
